import axios from "axios";
import apiurl from "./Api";

export const logout = (navigate) => {
  try {
     axios.post(apiurl + 'logout.php');
    navigate('/');
  } catch (err) {
    console.error("Logout error:", err);
  }
};
